<template>
    <div class="rr-checkout__step rr-checkout__step_user" v-show="active">
        <div uk-grid>
            <div class="uk-width-1-1">
                <div class="rr-checkout__wrapper">
                    <ul class="uk-list" uk-switcher>
                        <li><a href="#">{{ $t('rubinred.ecommerce.orders.checkout.step-1.no_user') }}</a></li>
                        <li><a href="#">{{ $t('rubinred.ecommerce.orders.checkout.step-1.user') }}</a></li>
                    </ul>
                    <ul class="uk-switcher rr-checkout__content uk-margin-top">
                        <li>
                            <rubinred-form class="uk-form-stacked form--bordered" ref="form" :async="true" :action="endpoint">
                                <div class="uk-grid-small" uk-grid slot="fields">
                                    <div class="uk-width-1-2@m">
                                        <form-input
                                            :label="$t('platform.users.auth.form.first_name')"
                                            slug="first_name"
                                            :validations="['required']"
                                        ></form-input>
                                    </div>
                                    <div class="uk-width-1-2@m">
                                        <form-input
                                            :label="$t('platform.users.auth.form.last_name')"
                                            slug="last_name"
                                            :validations="['required']"
                                        ></form-input>
                                    </div>
                                    <div class="uk-width-1-1">
                                        <form-input
                                            type="email"
                                            :label="$t('platform.users.auth.form.email')"
                                            name="email"
                                            slug="email"
                                            :validations="['required']"
                                        ></form-input>
                                    </div>
                                    <div class="uk-width-1-1">
                                        <form-checkboxes
                                            name="register"
                                            slug="register"
                                            :values="{'true': $t('rubinred.ecommerce.orders.checkout.step-1.register')}"
                                        ></form-checkboxes>
                                    </div>
                                </div>
                            </rubinred-form>
                        </li>
                        <li>
                            <slot name="login"></slot>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import CheckoutStep from 'rubinred/ecommerce/js/mixins/CheckoutStep'

  export default {
    mixins: [CheckoutStep],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/steps/RubinredCheckoutUserStep.vue